module.exports = __webpack_public_path__ + "img/teamBackground.c717f6d8.png";